export default "__VITE_ASSET__CW2ygDTY__"